<template>
    <div class="about">
        <!-- banner -->
        <div class="banner">
            <div class="banner_text">
                <!-- <p>平台介绍</p>
                <p>Platform Introduction</p> -->
            </div>
            <img v-if="banner" :src="banner" alt="" />
			<img v-else src="./../../assets/images/home/news_banner.png" alt="" />
            <!-- <img src="./../../assets/images/home/news_banner.png" alt="" />  -->
        </div>
        <div class="main">
            <ul class="list">
                <li class="item" v-for="item in aboutData" :key="item.id">
                    <div class="title"><img :src="item.picUrl" alt=""></div>
                    <div class="ql-editor content" v-html="item.content">
                        <!-- <p>中国测绘科学研究院（简称“测科院”）成立于1959年，隶属于自然资源部，是国内测绘地理信息最大的多学科综合性研究机构和唯一的中央级公益性科研院所，甲级测绘资质单位，通过ISO质量管理体系认证。先后走出5位院士，取得一批重大科技成果，引领了测绘地理信息技术变革，为我国各个时期经济社会发展提供了坚实的测绘地理信息科技保障。测科院是新型基础测绘和实景三维中国建设的顶层设计与技术支撑单位，是MA标识管理委员会的发起单位之一，是MA基础地理实体标识全球根节点的授权单位，正在规划建设国家节点、省区或城市MA基础地理实体节点，并组织开展全国MA基础地理实体标识注册、解析服务等工作。</p> -->
                    </div>
                </li>
                <!-- <li class="item">
                    <div class="title"><img src="./../../assets/images/home/about_logo1.png" alt=""></div>
                    <div class="content">
                        <p>中国测绘科学研究院（简称“测科院”）成立于1959年，隶属于自然资源部，是国内测绘地理信息最大的多学科综合性研究机构和唯一的中央级公益性科研院所，甲级测绘资质单位，通过ISO质量管理体系认证。先后走出5位院士，取得一批重大科技成果，引领了测绘地理信息技术变革，为我国各个时期经济社会发展提供了坚实的测绘地理信息科技保障。测科院是新型基础测绘和实景三维中国建设的顶层设计与技术支撑单位，是MA标识管理委员会的发起单位之一，是MA基础地理实体标识全球根节点的授权单位，正在规划建设国家节点、省区或城市MA基础地理实体节点，并组织开展全国MA基础地理实体标识注册、解析服务等工作。</p>
                    </div>
                </li>
                <li class="item">
                    <div class="title"><img src="./../../assets/images/home/about_logo2.png" alt=""></div>
                    <div class="content">
                        <p>中关村工信二维码技术研究院（简称：中码院，ZIIOT）成立于2014年，是专注于标识技术研究和标准制订的科研服务机构，2018年获得国际标准化组织（ISO）、欧洲标准委员会（CEN）、国际自动识别与移动技术协会（AIM）三大国际组织共同批准认可，成为中国唯一一家面向全球发行代码的标识管理机构，负责管理维护ISO/IEC 15459系列国际标准MA标识体系，建立MA标识全球根服务系统和注册解析国际顶级节点，向全球发行代码。同时，中码院已获得环球银行同业金融电讯协会（SWIFT）关联代码，与MA国际标识代码相结合，用于数据要素和数字资产的确权、交易。2022年6月，工业和信息化部为中码院签发了工业互联网标识注册管理机构许可证，“MA”国际标识代码正式纳入国家工业互联网标识体系。</p>
                    </div>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import {acticleList} from '@/api/home'
export default {
    name:"About",
    data(){
        return {
            aboutData:[],
            banner:'',
        }
    },
    mounted(){
        this.acticleList();
        this.banner = this.$route.query.banner || '';
        console.log(this.banner,"  this.banner")
    },
    methods:{
        acticleList(){//通过栏目id获取内容列表
            acticleList({
                columnId:this.$route.query.id,//栏目id 3
            }).then(res=>{
                // console.log('关于我们');
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.aboutData=res.data||[]
            })
        },
    }
}
</script>

<style lang='scss' scoped>
    .about{
        background-color: #fff;
       width: 100%;
	height: 100%;
	overflow: hidden auto;
	padding-bottom: 84px;
	box-sizing: border-box;
        .banner{
            width: 100%;
            position: relative;
            font-size: 0;
            .banner_text{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 1200px;
                // border: 1px solid #0f0;
                p:nth-child(1){
                    font-size: 30px;
                    color: #333;
                }
                p:nth-child(2){
                    font-size: 24px;
                    color: #C9ECE1;
                    margin-top: 15px;
                    // width: 640px;
                    color: #333;
                    line-height: 41px;
                }
            }
            img{
                width: 100%;
                object-fit: fill;
                max-height: 200px;
            }
        }
        .main{
            padding: 40px 0 90px;
            box-sizing: border-box;
            .list{
                width: 1200px;
                margin: 0 auto;
                // border: 1px solid #f00;
                background-color: #fff;
                box-shadow: 0px 0px 20px 0px rgba(241,241,241,0.68);
                padding: 0 90px;
                box-sizing: border-box;
                .item{
                    padding: 40px 0;
                    box-sizing: border-box;
                    border-bottom: 1px solid #E6E6E6;
                    .title{
                        text-align: center;
                        font-size: 0;
                        img{
                            max-width: 100%;
                        }
                    }
                    .content{
                        // margin-top: 50px;
                        p{
                            line-height: 1.5;
                        }
                    }
                }
                li.item:last-child{
                    border-bottom: none;
                }
            }
        }
    }
</style>